import { styled } from '@mui/material/styles';
import {
  TextField as MuiTextField,
  InputLabel as MuiInputLabel,
  Typography,
} from "@mui/material";

export const TextFieldContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  width: "auto",
  gap: theme.space._200
}));

export const CustomInputLabel = styled(MuiInputLabel)(({ theme }) => ({
  color: theme.colors["neutral.200"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.base,

  transform: 'translate(0, 0) scale(1)',
}));

export const CustomTextField = styled(MuiTextField)(({ theme }) => ({
  cursor: "pointer",
  '& .MuiInputBase-input': {
    color: theme.colors["neutral.50"],
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.medium,
    lineHeight: theme.lineHeights.short,
    height: "20px",
    borderRadius: "8px",
    '&.Mui-disabled': {
      WebkitTextFillColor: theme.colors["neutral.50"],
    }
  },

  '& .Mui-disabled': {
    cursor: "not-allowed",
    pointerEvents: "auto",
    opacity: theme.opacity.intense,

    "svg": {
      color: theme.colors["neutral.600"]
    }
  },

  '& .MuiInputBase-root': {
    color: theme.colors["neutral.50"],
    '& fieldset': {
      borderRadius: "8px",
    },
    '&:hover fieldset': {
      borderColor: theme.colors["neutral.400"],
      borderRadius: "8px",
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.colors['blue.400'],
      borderRadius: "8px",
    },
  },

  '&.is-error': {
    '& .MuiInputBase-root': {
      '& fieldset': {
        borderColor: theme.colors["red.700"],
      },
      '&:hover fieldset': {
        borderColor: theme.colors["red.600"],
      },
      '&.Mui-focused fieldset': {
        borderColor: theme.colors["red.700"],
      },
    },
  }
}));

export const ErrorMessageTypography = styled(Typography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: "normal",
  fontWeight: theme.fontWeights.medium,
  lineHeight: theme.lineHeights.base,
  color: theme.colors["red.500"],
}));